<template>
  <div>
    <img
      :src="newsItem.publisher.logo.url"
      :alt="t('Изображение автора', options)"
      width="100%"
      height="120px"
      class="mb-4 news-image"
    >
    <div class="text-subtitle-1 text--text mb-4 px-2">
      {{ newsItem.header }}
    </div>
    <div class="text-body-1 text--text mb-4 px-2">
      {{ newsItemText }}
    </div>
    <v-btn
      v-if="newsItem.text.length > 100"
      class="primary--text"
      text
      @click="toggleShowMore"
    >
      {{ isShowMore ? t('Скрыть', options) : t('Показать всё', options) }}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, ref } from 'vue'
import I18NextVue from 'i18next'
import { Swiper } from 'swiper'
import { News } from 'src/components/pages/info/pressa/types'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  newsItem: News
  swiperInstance: Swiper | null
}>()

const isShowMore = ref(false)

async function toggleShowMore() {
  isShowMore.value = !isShowMore.value

  if (props.swiperInstance) {
    await nextTick()

    props.swiperInstance.updateAutoHeight(300)
  }
}

const newsItemText = computed(() => (
  isShowMore.value || props.newsItem.text.length <= 100
    ? `«${props.newsItem.text}»`
    : `«${props.newsItem.text.slice(0, 100)}...`))
</script>

<style>
.news-image {
  object-fit: contain;
}
</style>
